var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"download",attrs:{"title":"Download"},on:{"click":_vm.download}},[_c('IconDownload'),_c('form',{ref:"form",attrs:{"method":"POST","target":"_blank","action":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }